import React from 'react';
import type PlanSummaryType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-summary/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSummary = lazyForPaint<typeof PlanSummaryType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-summary", jiraSpaEntry: "async-plan-summary" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-summary'
			),
		),
	{ ssr: false },
);

const AsyncPlanSummary = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanSummary} pageId="plan-summary" shouldShowSpinner />
);

export default AsyncPlanSummary;
